import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Drawer from '../Common/Drawer/Drawer';
import Icon from '../Common/Icon';
import { CUSTOMER_ROLES } from '../../constants/roles';
import MultiSelectBox from '../Common/MultiSelectBox/MultiSelectBox';

export default class PrimeTable extends React.Component {
//https://www.primefaces.org/primereact/#/datatable

    constructor() {
        super();
        this.state = {
            sales: [
                { brand: 'Apple', lastYearSale: '51%', thisYearSale: '40%', lastYearProfit: '$54,406.00', thisYearProfit: '$43,342' },
                { brand: 'Samsung', lastYearSale: '83%', thisYearSale: '96%', lastYearProfit: '$423,132', thisYearProfit: '$312,122' },
                { brand: 'Microsoft', lastYearSale: '38%', thisYearSale: '5%', lastYearProfit: '$12,321', thisYearProfit: '$8,500' },
                { brand: 'Philips', lastYearSale: '49%', thisYearSale: '22%', lastYearProfit: '$745,232', thisYearProfit: '$650,323,' },
                { brand: 'Song', lastYearSale: '17%', thisYearSale: '79%', lastYearProfit: '$643,242', thisYearProfit: '500,332' },
                { brand: 'LG', lastYearSale: '52%', thisYearSale: ' 65%', lastYearProfit: '$421,132', thisYearProfit: '$150,005' },
                { brand: 'Sharp', lastYearSale: '82%', thisYearSale: '12%', lastYearProfit: '$131,211', thisYearProfit: '$100,214' },
                { brand: 'Panasonic', lastYearSale: '44%', thisYearSale: '45%', lastYearProfit: '$66,442', thisYearProfit: '$53,322' },
                { brand: 'HTC', lastYearSale: '90%', thisYearSale: '56%', lastYearProfit: '$765,442', thisYearProfit: '$296,232' },
                { brand: 'Toshiba', lastYearSale: '75%', thisYearSale: '54%', lastYearProfit: '$21,212', thisYearProfit: '$12,533' }
            ],
            firstName: "",
            selectedRoleId: "",
            selectedSale: null,
            drawerOpen: false,
            windowWidth: window.innerWidth,
        };
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleWindowSizeChange);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowSizeChange);
    }

    handleWindowSizeChange = () => {
        this.setState({ windowWidth: window.innerWidth });
    }

    sortItOut = () => {
        /*Do nothing*/
    }

    filterItOut = () => {
        /*Do nothing*/
    }

    selected = (e) => {
        this.setState({ selectedSale: e.data });

    }

    saveClick = () => {
        this.setState({ drawerOpen: false });
    }

    cancelClick = () => {
        this.setState({ drawerOpen: false });
    }

    showDrawer = (e) => {

        this.setState({ selectedSale: e.value, drawerOpen: true });
    }

    actionTemplate = () => {
        return <div className="text-success"><Icon name="check-circle" /></div>;
    }
    onRoleChange = (selectedValue) => {
        const val = (selectedValue) ? selectedValue.toString() : "";
        this.setState({ selectedRoleId: val });
    }
    render() {
        const roleOptions = [
            { label: "All", value: null },
            { label: CUSTOMER_ROLES.User.name, value: CUSTOMER_ROLES.User.id },
            { label: CUSTOMER_ROLES.Moderator.name, value: CUSTOMER_ROLES.Moderator.id },
            { label: CUSTOMER_ROLES.Admin.name, value: CUSTOMER_ROLES.Admin.id },
            { label: CUSTOMER_ROLES.Owner.name, value: CUSTOMER_ROLES.Owner.id }
        ];
        const displayColumns = (this.state.windowWidth < 500) ? 'none' : '';

        const roleIdFilter = <MultiSelectBox className="select-column-header" name="roleId" label="User Role" idField="value" valueField="label" options={roleOptions} isMulti={false} onChange={this.onRoleChange} selectedValues={this.state.selectedRoleId} />

        const firstNameFilter = 
            <input type="text" name="firstName" className="p-inputtext" onBlur={this.onSearchBlur} onChange={this.filterChange} onKeyUp={this.keyUpFilter} value={this.state.firstName} />
        ;

        return (
            <div className="guide-page">
                <h3 className="guide-title">Primereact Table</h3>
                <p className="guide-lead">View the documentation for this component here: <a href="https://www.primefaces.org/primereact/#/datatable">https://www.primefaces.org/primereact/#/datatable</a></p>
                <p>This is a basic example of how we are opening the drawer when a row is selected, and only showing certain columns for mobile view.</p>

                <DataTable
                    filterDisplay="row"
                    className="p-datatable-sm p-datatable-striped"
                    value={this.state.sales}
                    paginator={true}
                    sortMode="multiple"
                    rows={4}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
                    selectionMode="single"
                    selection={this.state.selectedSale} onSelectionChange={this.showDrawer}

                >
                    <Column field="roleName" header="User Role" filter={true} filterElement={roleIdFilter} style={{ display: displayColumns }} />
                    <Column field="firstName" header="First Name" body={this.firstNameTemplate} filter={true} filterElement={firstNameFilter} />
                    <Column field="brand" header="Brand" sortable="custom" sortFunction={this.sortItOut} filter={false} filterPlaceholder="Search" filterFunction={this.filterItOut}/>
                    <Column field="lastYearSale" header="lastYearSale" sortable="custom" sortFunction={this.sortItOut} style={{ display: displayColumns }}/>
                    <Column field="thisYearSale" header="thisYearSale" sortable="custom" sortFunction={this.sortItOut} style={{ display: displayColumns }}/>
                    <Column field="lastYearProfit" header="lastYearProfit" sortable="custom" sortFunction={this.sortItOut} style={{ display: displayColumns }}/>
                    <Column body={this.actionTemplate} style={{ textAlign: 'center', width: '6em' }} />
                </DataTable>

                {this.state.drawerOpen ?
                    <Drawer isWide={false} title="Sale Data" onSaveClick={this.saveClick} onCancelClick={this.cancelClick}>
                        <div><h2>{(this.state.selectedSale) ? this.state.selectedSale.brand : ''}</h2></div>
                        <div>Last Year Sales: {(this.state.selectedSale) ? this.state.selectedSale.lastYearSale : ''}</div>
                        <div>This Year Sales: {(this.state.selectedSale) ? this.state.selectedSale.thisYearSale : ''}</div>
                        <div>Last Year Profit: {(this.state.selectedSale) ? this.state.selectedSale.lastYearProfit : ''}</div>
                        <div>This Year Profit: {(this.state.selectedSale) ? this.state.selectedSale.thisYearProfit : ''}</div>
                    </Drawer>                
                :
                ""
                }

            </div>
        );
    }
}

